import { FC } from 'react'
import { SpectrumIdentityTypeEnum } from '../../../../common/enums/spectrumBankAccountEnum'

interface IProps {
  documentType: SpectrumIdentityTypeEnum | ''
  documentNumber: string
  onChangeDocumentType: (value: SpectrumIdentityTypeEnum | '') => void
  onChangeDocumentNumber: (value: string) => void
  disabled: boolean
}

const documentTypeLabels: Partial<Record<SpectrumIdentityTypeEnum, string>> = {
  [SpectrumIdentityTypeEnum.DNI]: 'DNI',
  [SpectrumIdentityTypeEnum.CE]: 'Carné de extranjería',
  [SpectrumIdentityTypeEnum.RUC]: 'RUC',
  [SpectrumIdentityTypeEnum.PASSPORT]: 'Pasaporte',
}

export const IdentityValidationFields: FC<IProps> = ({
  documentType,
  documentNumber,
  onChangeDocumentType,
  onChangeDocumentNumber,
  disabled,
}) => (
  <div className='row'>
    <div className='col-lg-6 mb-7'>
      <label htmlFor='documentType' className='text-muted fs-6 mb-2'>
        Tipo de documento
      </label>
      <select
        id='documentType'
        className='selectForm contract-select-toggle'
        value={documentType}
        disabled={disabled}
        onChange={(e) => onChangeDocumentType(e.target.value as SpectrumIdentityTypeEnum | '')}
      >
        <option value=''>Seleccione</option>
        {Object.entries(documentTypeLabels).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
    <div className='col-lg-6 mb-7'>
      <label htmlFor='documentNumber' className='text-muted fs-6 mb-2'>
        N° de documento
      </label>
      <input
        id='documentNumber'
        type='text'
        className='form-control form-control-solid'
        value={documentNumber}
        disabled={disabled}
        autoComplete='off'
        onChange={(e) => onChangeDocumentNumber(e.target.value)}
      />
    </div>
  </div>
)
